import { Label as SpUiLabel, styled } from 'sp-ui';

const Label = styled(SpUiLabel)`
    display: block;
`;

export default Label;
